<ion-header>
  <ion-toolbar>
    <ion-icon slot="start" name="chevron-back-outline" value="exit" (click)="dismiss()"></ion-icon>

    <div class="picDiv" slot="start">
      <img (click)="openProfile()" src="{{otherSoul.firstPic}}" class="chatPic" (error)="onImageError($event)">
    </div>

    <div class="nameInChat">
      {{otherSoul.firstName}}
      <img *ngIf="otherSoul?.userValidated" class="userValidated" src="assets/imgs/new-check-img.svg">
    </div>
  </ion-toolbar>
</ion-header>

<ion-content id="contentDiv">
  <ion-list lines="none">

    <!-- Talking to verified -->
    <div *ngIf="otherSoul?.userValidated && !userData?.userValidated" class="validated">
      <div class="banner">
        <img class="banner-badge" src="assets/imgs/new-check-img.svg" alt="" aria-hidden="true">
        <p>{{ 'youAreChattingWithVerifiedProfile' | translate }} <a (click)="handleValidation()">{{ 'verifyYourProfileToo'
            | translate }}</a></p>
      </div>
    </div>

    <!-- Verify your profile -->
    <div *ngIf="!otherSoul?.userValidated && !userData?.userValidated" class="validated">
      <div class="banner">
        <img class="banner-badge" src="assets/imgs/new-check-img.svg" alt="" aria-hidden="true">
        <p>{{ 'secureVegMatch' | translate }} <a (click)="handleValidation()">{{ 'verifyYourProfile' | translate }}</a>
        </p>
      </div>
    </div>

    <div class="new-vegmatch" *ngIf="isLoaded && messages.length === 0">
      {{ 'newVegMatchSayHi' | translate }}
    </div>

    <div class="message-item" *ngFor="let aMessage of messages; trackBy: trackMessage">

      <!-- Day Tag-->
      <div *ngIf="aMessage.newday" class="date">
        {{aMessage.date}}
      </div>

      <!-- Message Item-->

      <ion-item-sliding [id]="aMessage?._id.$oid + '-sliding'" #slidingItemRef>
        <ion-item lines="none" class="message-item" [class.reacted-message-item]="aMessage.reaction === 1"
          (touchstart)="handleTouchStart(aMessage)" (touchend)="handleTouchEnd(aMessage)">

          <div class="message-container {{aMessage.position}}">

            <!-- Big Bubble-->
            <div class="chat-bubble {{aMessage.position}}" [id]="aMessage?._id.$oid + '-bubble'"
              [ngClass]="'position-' + aMessage.position" [class.has-reply]="!!aMessage.inResponseTo"
              [class.recadinho-bubble]="isRecadinhoMessage(aMessage)"
              [class.has-audio]="!!aMessage.filename"
              [class.has-compliment-photo]="mostraFotoDoElogio(aMessage)"
              [class.has-reaction]="aMessage.reaction === 1">

              <!-- Response to-->
              <div *ngIf="aMessage.inResponseTo" class="replied-to-snippet {{aMessage.position}}"
                (click)="scrollToRespondedMessage(aMessage.inResponseTo.$oid)">
                <div class="replied-to-header">{{ aMessage.inResponseTo.owner }}</div>
                <div *ngIf="messagesMap.get(aMessage.inResponseTo.$oid)?.filename"
                  class="replied-to-content replied-to-content--audio">
                  <ion-icon name="mic-outline" class="replied-audio-icon"></ion-icon>
                  Audio {{ messagesMap.get(aMessage.inResponseTo.$oid)?.duration ? '(' +
                  messagesMap.get(aMessage.inResponseTo.$oid)?.duration + 's)' : '' }}
                </div>
                <div *ngIf="!messagesMap.get(aMessage.inResponseTo.$oid)?.filename"
                  class="replied-to-content replied-to-content--text">
                  {{ messagesMap.get(aMessage.inResponseTo.$oid)?.message }}
                </div>
              </div>

              <!-- Audio -->
              <div class="message-content-wrapper">

                <!-- Miniatura do Elogio ANTES do audio: no mockup a foto fica em cima e o
                     player embaixo. Antes a ordem era a inversa, por empilhamento de bloco. -->
                <div *ngIf="mostraFotoDoElogio(aMessage)" class="recadinho-photo-box">
                  <img class="recadinho-photo-thumb" [src]="complimentPhotoUrl(aMessage)"
                    (error)="onComplimentPhotoError(aMessage)" alt="">
                  <!-- Selo do Elogio no canto da FOTO, e nao da bolha.
                       `icon-elogio.svg` e o MESMO asset que o chat-list, a home, o
                       profile-display, a store e o recadinho usam — e ele ja e por app: aro
                       verde `#4ad861` no veggly, laranja `#ffb140` no fyra. Era `likewhitebg.svg`,
                       que e identico nos dois apps e nao tem aro, e por isso o selo do chat
                       aparecia com um desenho diferente do resto. -->
                  <img src="assets/imgs/icon-elogio.svg" class="recadinho-photo-badge"
                    (click)="showRecadinhoInfo()" alt="">
                </div>

                <div *ngIf="aMessage.filename" class="message-content message-content--audio">
                  <div class="audio-player">
                    <ion-button fill="clear" size="small" class="play-pause-button"
                      (click)="aMessage.isPlaying ? mediaSP.pauseAudio(aMessage) : mediaSP.playAudio(aMessage)">
                      <ion-icon [name]="aMessage.isPlaying ? 'pause' : 'play'" slot="icon-only"
                        class="audio-control-icon"></ion-icon>
                    </ion-button>
                    <div class="audio-track">
                      <div class="audio-progress" [style.width.%]="aMessage.playbackProgress || 0"></div>
                      <div class="audio-scrubber" *ngIf="aMessage.isPlaying"></div>
                    </div>
                  </div>
                </div>

                <!-- Interpolação colada nas tags: com white-space: pre-wrap, o espaço/indentação
                     do template viraria um recuo no 1º caractere da mensagem. -->
                <div *ngIf="!aMessage.filename" class="message-content message-content--text selectext">{{aMessage.message}}</div>
              </div>

              <!-- Message Time and Status.
                   No audio, a duracao entra AQUI em vez de dentro do player: o mockup poe
                   duracao a esquerda e hora a direita na MESMA linha, e antes eram dois blocos
                   irmaos empilhados. -->
              <div class="message-meta {{aMessage.position}}" [class.has-duration]="aMessage.filename">
                <span *ngIf="aMessage.filename" class="audio-duration">{{ formatarDuracaoDoAudio(aMessage.isPlaying ?
                  aMessage.currentTimePlayed : aMessage.duration) }}</span>
                <!-- Hora e check agrupados: com a duracao na mesma linha, o
                     `justify-content: space-between` passa a ter TRES filhos e joga a hora
                     para o MEIO. Agrupados, sao dois blocos — duracao numa ponta, hora+check
                     na outra. -->
                <span class="message-meta__end">
                  <span class="message-time">{{aMessage.time}}</span>
                  <!-- Check duplo: mensagem lida.
                       O `!aMessage.filename` saiu daqui. Com ele, o audio LIDO nao mostrava
                       check nenhum: o duplo era bloqueado pelo filename e o simples exige
                       `read === false`. O audio enviado passava a nao ter confirmacao de
                       leitura, ao contrario do texto. -->
                  <ion-icon *ngIf="aMessage.position === 'right' && aMessage.read === true"
                    name="checkmark-done-outline" class="message-status-icon message-status-icon--read">
                  </ion-icon>
                  <!-- Check simples: enviada e ainda nao lida -->
                  <ion-icon *ngIf="aMessage.position === 'right' && aMessage.read === false" name="checkmark-outline"
                    class="message-status-icon message-status-icon--sent">
                  </ion-icon>
                </span>
              </div>

              <!-- Reaction Badge -->
              <div *ngIf="aMessage.reaction === 1" class="reaction-badge {{aMessage.position}}">
                <img src="assets/imgs/likegreenbg.svg" alt="Liked" class="reaction-icon">
              </div>
            </div>
          </div>
        </ion-item>

        <!-- Reply Icon-->
        <ion-item-options side="start" (ionSwipe)="showRespondMessage(aMessage, slidingItemRef)">
          <ion-item-option class="reply-option-background" (click)="showRespondMessage(aMessage, slidingItemRef)">
            <ion-icon name="arrow-undo-outline" slot="icon-only" class="reply-swipe-icon"></ion-icon>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>

      <div *ngIf="aMessage.reactionHint" class="message-hint {{aMessage.position}}">
        {{"doubleClickToLike" | translate}}
      </div>

      <div *ngIf="aMessage.respondHint" class="message-hint {{aMessage.position}}">
        {{"swipeRightToReply" | translate}}
      </div>

      <div *ngIf="aMessage.readingConfirmationCallout" class="reading-confirmation-callout"
        (click)="openAvocadoStore()">
        <div>{{ "doYouWantToKnowIfTheyReadYourMessage" | translate }} <a>{{ "yesTurnItOn" | translate }}</a></div>
      </div>
    </div>
  </ion-list>
</ion-content>

<!-- Input + gate do elogio fixos no rodapé (chat normal; conteúdo não fica “scrollado”) -->
<ion-footer class="chat-input-footer"
  [class.has-recadinho-gate]="recadinhoReceiverGate"
  [class.has-recadinho-lock]="recadinhoSenderLock">
  <div class="send-message-content"
    [class.has-fab-button]="showFab"
    [class.has-recadinho-gate]="recadinhoReceiverGate"
    [class.has-recadinho-lock]="recadinhoSenderLock">

    <ion-button (click)="scrollToBottom()" *ngIf="showFab">
      <ion-icon size="large" name="chevron-down-circle-outline"></ion-icon>
    </ion-button>

    <!-- Recadinho remetente: aguardando o like de volta para poder mandar mais mensagens -->
    <div *ngIf="recadinhoSenderLock" class="recadinho-sender-lock">
      <p class="lock-text">{{'recadinhoSenderWaiting' | translate:{ name: otherSoul?.firstName } }}</p>
    </div>

    <!-- Recadinho destinatário (sem match): curtir de volta (grátis) ou responder por 1 cenoura.
         No XD as duas opcoes sao um paragrafo so, acima do botao. "Responder sem curtir" segue
         tocavel, e enviar pelo campo leva ao mesmo fluxo (ver `send()`). -->
    <div *ngIf="recadinhoReceiverGate" class="recadinho-gate">
      <p class="gate-text">{{'likeToContinueChatFree' | translate}}
        <span class="gate-alt" (click)="replyWithoutLike()">{{'replyWithoutLikeForOneCarrot' | translate}}</span>
      </p>
      <ion-button shape="round" color="primary" class="gate-like-btn" (click)="likeBackFromRecadinho()">
        {{'like' | translate}}
      </ion-button>
    </div>

    <!-- Regular Message-->
    <!-- Audio gravado e nao enviado: ouvir / descartar / enviar -->
    <!-- Mesma estrutura do compositor: pílula com o conteúdo + botão FORA, à
         direita. Reusa .message-form/.input-actions/.sendButton de propósito —
         assim o tamanho e o alinhamento são idênticos por construção, e não por
         coincidência de valores repetidos. -->
    <div *ngIf="!mediaSP.recording && hasRecordedAudio" class="message-form audio-review-row">
      <div class="textAreaWrapper audio-review">
        <ion-button class="review-play" fill="clear" (click)="togglePreview()"
          [attr.aria-label]="(isPreviewPlaying ? 'pause' : 'play') | translate">
          <ion-icon [name]="isPreviewPlaying ? 'pause' : 'play'" slot="icon-only"></ion-icon>
        </ion-button>
        <span class="review-dur">{{ mediaSP.duration }}s</span>
        <ion-button class="review-discard" fill="clear" (click)="discardRecordedAudio()"
          [attr.aria-label]="'delete' | translate">
          <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
      <div class="input-actions">
        <ion-button class="sendButton" (click)="sendRecordedAudio()"
          [attr.aria-label]="'send' | translate">
          <img src="assets/imgs/awesome-location-arrow.svg" alt="Send-audio">
        </ion-button>
      </div>
    </div>

    <div *ngIf="!mediaSP.recording && !hasRecordedAudio">
      <form [formGroup]="myForm" class="message-form">

        <!-- Response to-->
        <!-- O clique em QUALQUER ponto da pilula encaminha o foco ao campo, que e o
             que o `ion-item` removido fazia por dentro (comportamento nativo de
             label). Sem isto sobrava uma zona morta: o padding de 14px a esquerda
             e 6px a direita nao pertence ao textarea, e clicar ali nao focava
             nada — medido no aparelho, o foco ia para o `ion-modal`.
             `setFocus()` e o metodo publico do ion-textarea; `#chatInput` e a
             referencia que ja existia no template. -->
        <div class="textAreaWrapper" (click)="chatInput.setFocus()" [class.has-reply]="respondingMessage" [class.has-content]="theMsgControl.value.length>0||respondingMessage">

          <!--Response-->
          <div *ngIf="respondingMessage" class="replied-to-snippet {{respondedMessage.position}}">
            <div class="replied-to-header">
              <ng-container *ngIf="respondedMessage?.position === 'right'">
                {{ 'you' | translate }}
              </ng-container>
              <ng-container *ngIf="respondedMessage?.position === 'left'">
                {{ otherSoul?.firstName }} </ng-container>
            </div>

            <div *ngIf="respondedMessage?.filename" class="replied-to-content replied-to-content--audio">
              <ion-icon name="mic-outline" class="replied-audio-icon"></ion-icon>
              Audio {{ respondedMessage?.duration ? '(' + respondedMessage?.duration + 's)' : '' }}
            </div>
            <div *ngIf="!respondedMessage?.filename" class="replied-to-content replied-to-content--text">
              {{ respondedMessage?.message }}
            </div>
            <ion-icon name="close" (click)="dismissRespondMessage()" class="close-icon"></ion-icon>
          </div>
          <!-- Sem ion-item: ele existia so para embrulhar o campo, e trazia o
               layout de item do Ionic que depois era desfeito no SCSS. A pilula
               e a borda vem do .textAreaWrapper.
               Saiu tambem `autosize` (nao existe no Ionic — quem faz crescer e
               o [autoGrow]) e `clearInput` (e propriedade do ion-input). -->
          <ion-textarea rows="1" #chatInput spellcheck="true" [autoGrow]="true" autocomplete="on"
            autocorrect="on" (ionFocus)="changeUserTypingState(true)"
            (ionBlur)="changeUserTypingState(false)" formControlName="msgControl"
            placeholder="{{ 'typeYourMessage' | translate }}">
          </ion-textarea>
        </div>

        <div class="input-actions">
          <!-- Com o gate do elogio o microfone SAI e o botao de enviar fica no lugar, como no XD:
               quem recebeu e nao curtiu so pode responder por texto, pagando. Antes o microfone
               ficava desabilitado — `recadinhoReceiverGate` tinha entrado no [disabled] porque o
               gate so bloqueava TEXTO e o audio passava direto pelo paywall. O guard no
               `startRecord()` continua fechando pelo codigo. -->
          <ion-button class="audioButton" (click)="startRecord()"
            [disabled]="recadinhoSenderLock"
            *ngIf="theMsgControl.value.length===0 && !recadinhoReceiverGate">
            <img src="assets/imgs/microphone.svg" alt="SendAudio">
          </ion-button>
          <ion-button fill="clear" class="sendButton" *ngIf="theMsgControl.value.length>0 || recadinhoReceiverGate"
            [disabled]="recadinhoSenderLock" (click)="send()">
            <img src="assets/imgs/awesome-location-arrow.svg" alt="Send message">
          </ion-button>
        </div>
      </form>
    </div>

    <!-- Audio Message-->
    <div class="recordingFooter" *ngIf="mediaSP.recording">
      <div class="recording-text" [class.has-content]="respondingMessage" [class.has-reply]="respondingMessage">
        <!-- Response to-->
          <div *ngIf="respondingMessage" class="replied-to-snippet {{respondedMessage.position}}">
            <div class="replied-to-header">
              <ng-container *ngIf="respondedMessage?.position === 'right'">
                {{ 'you' | translate }}
              </ng-container>
              <ng-container *ngIf="respondedMessage?.position === 'left'">
                {{ otherSoul?.firstName }} </ng-container>
            </div>

          <div *ngIf="respondedMessage?.filename" class="replied-to-content replied-to-content--audio">
            <ion-icon name="mic-outline" class="replied-audio-icon"></ion-icon>
            Audio {{ respondedMessage?.duration ? '(' + respondedMessage?.duration + 's)' : '' }}
          </div>
          <div *ngIf="!respondedMessage?.filename" class="replied-to-content replied-to-content--text">
            {{ respondedMessage?.message }}
          </div>
          <ion-icon name="close" (click)="dismissRespondMessage()" class="close-icon"></ion-icon>
        </div>


        <div class="recording-text-inner">
          <div class="cancelButton" shape="round" color="primary" (click)="cancelAudio()">
            <ion-icon src="assets/imgs/custom-svg/trash.svg"></ion-icon>
            <div class="cancelText">
              {{'cancel' | translate}}
            </div>
          </div>
          <div (swipe)="swipeEventAudio($event)" class="audio-time">
            <div class="time-elapsed">0:{{formattedelapsed}}</div>
          </div>
        </div>
      </div>
      <!-- Parar SEM enviar: leva para a revisao, onde da para ouvir. -->
      <ion-button fill="clear" class="stopButton" (click)="stopRecord()"
        *ngIf="mediaSP.recording" [attr.aria-label]="'stop' | translate">
        <ion-icon name="stop" slot="icon-only"></ion-icon>
      </ion-button>
      <!-- Caminho rapido preservado: um toque para, envia e pronto. -->
      <ion-button fill="clear" class="sendButton" (click)="stopAndSend()"
        *ngIf="mediaSP.recording || mediaSP.recording&&theMsgControl.value.length===0">
        <img src="assets/imgs/awesome-location-arrow.svg" alt="Stop-recording">
      </ion-button>
    </div>
  </div>
</ion-footer>